import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { clearMCQContext } from "../utils/mcqContext";

function Features() {
  const navigate = useNavigate();

  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [userScore, setUserScore] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    fetch("https://edunet.kmechengineering.com/root-engine1/api/features")
      .then((res) => res.json())
      .then((data) => {
        setFeatures(data?.feature_data || []);
        setLoading(false);
      })
      .catch(() => {
        setFeatures([]);
        setLoading(false);
      });
  }, []);

  useEffect(() => {

    const user =
      JSON.parse(localStorage.getItem("user"));

    if (!user) return;

    fetch(
      `https://edunet.kmechengineering.com/root-engine1/api/user-score?user_id=${user.id}`
    )
      .then((res) => res.json())
      .then((data) => {

        if (data.status) {
          setUserScore(data.score);
        }

      })
      .catch((err) => {
        console.log(err);
      });

  }, []);

  // Feature Navigation
   const handleFeatureNavigation = (feature) => {

     if (!feature) {
       alert("Feature not found!");
       return;
     }

     // Challenge Card
     if (
       feature.title.toLowerCase() === "challenge"
     ) {

       const score = userScore;

       if (score < 1000) {

         alert(
           `Challenge Mode is locked.

   Current Score : ${score}

   Required Score : 1000`
         );

         return;
       }

      const user =
        JSON.parse(localStorage.getItem("user"));

      localStorage.setItem(
        "tournament_user_id",
        user.id
      );

      window.location.href =
        "https://edunet.kmechengineering.com/tournament-frontend";

      return;
     }

     // Clear previous session
     clearMCQContext();

     localStorage.removeItem("review_mcq_data");
     localStorage.removeItem("review_essay_data");
     localStorage.removeItem("selected_grade");
     localStorage.removeItem("selected_stream");
     localStorage.removeItem("feature_id");
     localStorage.removeItem("feature_title");
     localStorage.removeItem("feature_route");


     // Save selected feature
     localStorage.setItem("feature_id", feature.id);
     localStorage.setItem("feature_title", feature.title);
     localStorage.setItem("feature_route", feature.route);

     // Video
     if (
       feature.title.toLowerCase() === "video"
     ) {
       navigate("/video-gallery");
       return;
     }

     // MCQ / Essay
     navigate("/select-grade", {
       state: {
         feature: feature,
       },
     });
   };

  return (
    <section
      style={{
        padding: isMobile ? "40px 16px" : "60px 20px",
        background: "transparent",
        textAlign: "center",
        position: "relative",
        zIndex: 2,
      }}
    >
      <h2
        style={{
          fontSize: isMobile ? "24px" : "30px",
          marginBottom: isMobile ? "30px" : "50px",
          color: "#ffffff",
        }}
      >
        What You Can Do
      </h2>

      {loading && (
        <p style={{ color: "#fff" }}>
          ⏳ Loading...
        </p>
      )}

      {!loading && features.length > 0 && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(220px, 260px))",
            justifyContent: "center",
            gap: isMobile ? "20px" : "30px",
          }}
        >
          {features.map((feature) => (
            <div
              key={feature.id}
              onClick={() => handleFeatureNavigation(feature)}
              style={{
                ...premiumCard,
                width: "100%",
                maxWidth: "260px",
                height: "260px",
                padding: isMobile ? "20px" : "30px",
              }}
              onMouseEnter={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform =
                    "translateY(-8px) scale(1.02)";
                  e.currentTarget.style.boxShadow =
                    "0 0 60px rgba(99,102,241,0.8)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform =
                    "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    premiumCard.boxShadow;
                }
              }}
            >
              <div
                style={{
                  ...iconCircle,
                  width: isMobile ? "64px" : "84px",
                  height: isMobile ? "64px" : "84px",
                }}
              >
                <img
                  src={
                    feature.icon_path?.startsWith("http")
                      ? feature.icon_path
                      : "https://edunet.kmechengineering.com/icons/mcq.png"
                  }
                  alt={feature.title}
                  style={{
                    width: isMobile ? "30px" : "40px",
                    height: isMobile ? "30px" : "40px",
                    objectFit: "contain",
                  }}
                  onError={(e) => {
                    e.target.src =
                      "https://edunet.kmechengineering.com/icons/mcq.png";
                  }}
                />
              </div>

              <h3
                style={{
                  marginBottom: "10px",
                  fontSize: isMobile ? "18px" : "20px",
                  color: "#fff",
                }}
              >
                {feature.title}
              </h3>


              {
                  feature.title.toLowerCase() === "challenge" &&
                  userScore < 1000 && (
                  <p
                    style={{
                      color: "#facc15",
                      fontSize: "13px",
                      marginBottom: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    🔒 Unlock at 1000 Score
                  </p>
                )
              }

              <p
                style={{
                  color: "#cbd5f5",
                  fontSize: isMobile ? "13px" : "14px",
                  marginBottom: "16px",
                }}
              >
                {feature.description}
              </p>

              <span
                style={{
                  ...ctaText,
                  fontSize: isMobile ? "14px" : "15px",
                }}
              >
                Start Practice →
              </span>
            </div>
          ))}
        </div>
      )}

      {!loading && features.length === 0 && (
        <p style={{ color: "red" }}>
          ❌ No Features Found
        </p>
      )}
    </section>
  );
}

export default Features;

const premiumCard = {
  width: "100%",
  borderRadius: "20px",
  background: "linear-gradient(145deg, #0f172a, #020617)",
  border: "1px solid rgba(99,102,241,0.5)",
  boxShadow: "0 0 40px rgba(99,102,241,0.45)",
  cursor: "pointer",
  transition: "all 0.3s ease",
  textAlign: "center",
};

const iconCircle = {
  borderRadius: "50%",
  background: "linear-gradient(135deg, #6366f1, #9333ea)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto 18px",
  boxShadow: "0 0 25px rgba(99,102,241,0.7)",
};

const ctaText = {
  color: "#6366f1",
  fontWeight: "700",
};
